// Car-Includes
export { default as CarsFullyRefurbished } from './CarsFullyRefurbished.svg';
export { default as CarLegalitiesChecked } from './AllLegalitiesAreChecked.svg';
export { default as CarInspectedBySylndr } from './CarsInspectedBySylndr.svg';
export { default as CarNintyDays } from './90DaysWarranty.svg';
export { default as CarNoAccidents } from './CarsNoAcc.svg';
export { default as CarOwnedBySylndr } from './CarOwnedBySylndr.svg';
export { default as CarOwnedByCertifiedDealer } from './CarOwnedByCertifiedDealer.svg';
export { default as CarSevenDaysReturn } from './7DaysPolicy.svg';

// Car-Badges
export { default as CarCertified } from './CarCertified.svg';
export { default as CarLite } from './CarLite.svg';
export { default as CarDealer } from './CarDealer.svg';
export { default as CertifiedCarBagde } from './CertifiedCarBadge.svg';
export { default as LiteCarBagde } from './LiteCarBadge.svg';
export { default as DealerCarBagde } from './DealerCarBadge.svg';
export { default as HighlightsIcon } from './highlights-icon.svg';

// Video-Thumbnail
export { default as VideoThumbnail } from './VideoEntryPoint.svg';
export { default as SylndrHelpVideoThumbnail } from './SylndrHelpVidEntryPoint.svg';

export { default as CheckCircle } from './check-circle.svg';
export { default as PlayCircle } from './playCircle.svg';

export { default as ReInspect } from './ReInspect.svg';
export { default as BuyFromSylndr } from './BuyFromSylndr.svg';

export { default as ReInspectMini } from './ReInspectMini.svg';
export { default as BuyFromSylndrMini } from './BuyFromSylndrMini.svg';

export { default as BuyFromSylndrMiniAr } from './BuyFromSylndrMini-ar.svg';
export { default as ReInspectMiniAr } from './ReInspectMini-ar.svg';

export { default as InfoCircleBlue } from './infoCircle.svg';
